var _rect, _path, _rect2, _rect3, _path2, _rect4, _path3, _path4, _path5, _rect5, _path6, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHdmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 150,
    viewBox: "0 0 89 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.1807,
    y: 0.5,
    width: 18,
    height: 21,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1807 0.5L71.1807 22",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1807,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1807,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6807 16H56.6807C55.5761 16 54.6807 16.8954 54.6807 18V37.2528C54.6807 37.7347 54.8594 38.1961 55.152 38.579C57.6922 41.9017 58.8636 46.8471 59.2822 50.1048C59.4182 51.1632 60.2957 52 61.3628 52H81.3386C82.4431 52 83.3304 51.1024 83.4214 50.0015C83.8573 44.7264 85.9173 40.5366 87.2718 38.559C87.5259 38.1879 87.6807 37.7554 87.6807 37.3057V18C87.6807 16.8954 86.7852 16 85.6807 16Z",
    fill: "white",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.6807,
    y: 52,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1807 57V118C75.1807 135.397 61.0776 149.5 43.6807 149.5C26.2837 149.5 12.1807 135.397 12.1807 118V113.5H19.5V118C19.5 131.531 30.1497 142.5 43.6807 142.5C57.2116 142.5 68.1807 131.531 68.1807 118V57H75.1807Z",
    fill: "white",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00024 63C2.6702 63 0.833313 64.9836 1.01202 67.3068L3.39664 98.3068C3.40728 98.4451 3.42487 98.5813 3.44905 98.7152C3.86206 101.001 5.68064 103.101 5.68064 105.424V108C5.68064 111.314 8.36693 114 11.6806 114H20.6806C23.9944 114 26.6806 111.314 26.6806 108V105.424C26.6806 103.101 28.4994 101.001 28.9124 98.7151C28.9366 98.5813 28.9542 98.4451 28.9648 98.3068L31.3494 67.3068C31.5281 64.9836 29.6913 63 27.3612 63H5.00024Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01202 67.3068L1.51055 67.2684L1.01202 67.3068ZM3.39664 98.3068L3.89516 98.2684L3.39664 98.3068ZM28.9648 98.3068L28.4663 98.2684L28.9648 98.3068ZM31.3494 67.3068L31.848 67.3451L31.3494 67.3068ZM28.9124 98.7151L28.4204 98.6262L28.9124 98.7151ZM1.51055 67.2684C1.35418 65.2357 2.96145 63.5 5.00024 63.5V62.5C2.37894 62.5 0.312448 64.7316 0.513492 67.3451L1.51055 67.2684ZM3.89516 98.2684L1.51055 67.2684L0.513492 67.3451L2.89811 98.3451L3.89516 98.2684ZM3.94108 98.6262C3.91991 98.5091 3.9045 98.3898 3.89516 98.2684L2.89811 98.3451C2.91006 98.5005 2.92982 98.6536 2.95702 98.8041L3.94108 98.6262ZM6.18064 108V105.424H5.18064V108H6.18064ZM11.6806 113.5C8.64308 113.5 6.18064 111.038 6.18064 108H5.18064C5.18064 111.59 8.09079 114.5 11.6806 114.5V113.5ZM20.6806 113.5H11.6806V114.5H20.6806V113.5ZM26.1806 108C26.1806 111.038 23.7182 113.5 20.6806 113.5V114.5C24.2705 114.5 27.1806 111.59 27.1806 108H26.1806ZM26.1806 105.424V108H27.1806V105.424H26.1806ZM28.4663 98.2684C28.457 98.3898 28.4415 98.5091 28.4204 98.6262L29.4044 98.8041C29.4316 98.6536 29.4514 98.5005 29.4633 98.3451L28.4663 98.2684ZM30.8509 67.2684L28.4663 98.2684L29.4633 98.3451L31.848 67.3451L30.8509 67.2684ZM27.3612 63.5C29.4 63.5 31.0073 65.2357 30.8509 67.2684L31.848 67.3451C32.049 64.7316 29.9825 62.5 27.3612 62.5V63.5ZM5.00024 63.5H27.3612V62.5H5.00024V63.5ZM27.1806 105.424C27.1806 104.384 27.5884 103.368 28.0959 102.265C28.5875 101.195 29.1837 100.026 29.4044 98.8041L28.4204 98.6262C28.2281 99.69 27.7084 100.714 27.1874 101.847C26.6822 102.946 26.1806 104.142 26.1806 105.424H27.1806ZM2.95702 98.8041C3.17779 100.026 3.77391 101.195 4.26544 102.264C4.77287 103.368 5.18064 104.384 5.18064 105.424H6.18064C6.18064 104.141 5.67912 102.945 5.17401 101.847C4.653 100.713 4.13332 99.69 3.94108 98.6262L2.95702 98.8041Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 59.6807,
    y: 21,
    width: 23,
    height: 7,
    rx: 1,
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84372 69.1414C5.75766 68.539 6.22512 68 6.83367 68H25.5277C26.1362 68 26.6037 68.539 26.5176 69.1414L25.8033 74.1414C25.7329 74.6341 25.311 75 24.8134 75H7.54796C7.05031 75 6.62839 74.6341 6.55801 74.1414L5.84372 69.1414Z",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1807,
    y: 33.5,
    width: 16,
    height: 3,
    rx: 1.5,
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.18066,
    y: 89.5,
    width: 16,
    height: 3,
    rx: 1.5,
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.1807,
    y: 95.5,
    width: 12,
    height: 3,
    rx: 1.5,
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63.1807,
    y: 39.5,
    width: 16,
    height: 3,
    rx: 1.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHdmi);
export default __webpack_public_path__ + "static/media/ic-hdmi.f409c6ff78964d1d00b770933322e72e.svg";
export { ForwardRef as ReactComponent };